import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import {
  userIsAdmin,
  userIsManager,
  userCanSeeComments,
} from '../../helpers/Auth';
import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalAllowComments = (({
  allowComments,
  hideFileDetails,
  handleChangeAllowComments,
  handleClose,
}) => {
  const intl = useIntl();

  const disabled = hideFileDetails || !canUserManageShare() || !userCanSeeComments();

  return (
    <div
      className="share-allow-comments share-setting"
    >
      <Label for="inpAllowComments" className={classnames('switch', { disabled })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Allow comments' })}
          <HelpIcon id="share-allow-comments">
            {intl.formatMessage({ defaultMessage: 'Allow recipients to add comments on files.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-allow-comments" simple={true} />
          {hideFileDetails && (
            <HelpIcon id="share-allow-comments-disabled" permanent={true}>
              {intl.formatMessage({ defaultMessage: 'Enable file details to allow commenting' })}
            </HelpIcon>
          )}
          {userHasFeature('share-allow-comments') && (
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="allow-comments"
                id="inpAllowComments"
                value={true}
                checked={allowComments && userCanSeeComments()}
                disabled={disabled}
                onChange={handleChangeAllowComments}
              />
              <i />
            </div>
          )}
        </div>
      </Label>
      {((userIsAdmin() || userIsManager()) && !userCanSeeComments()) && (
        <div className="restricted-notice">
          {intl.formatMessage({ defaultMessage: 'Enable comments in your <link>workspace settings</link>' }, {
            link: (msg) => (
              <Link to="/admin/settings/file-commenting-and-favoriting" onClick={handleClose}>
                {msg}
              </Link>
            ),
          })}
        </div>
      )}
    </div>
  );
});

ShareModalAllowComments.propTypes = {
  allowComments: PropTypes.bool.isRequired,
  hideFileDetails: PropTypes.bool.isRequired,
  handleChangeAllowComments: PropTypes.func.isRequired,
  handleClose: PropTypes.func,
};

ShareModalAllowComments.defaultProps = {
  handleClose: () => {},
};

export default ShareModalAllowComments;
